import { useState } from "react"
import { useForm } from "react-hook-form"
import { useDispatch, useSelector } from "react-redux"
import { AppToast } from "../../../../lib/toast"
import { resetFormAuthentication, setKeyReset } from "../../../../store/auth/authSlice"
import { PasswordFormFieldsConfig } from "../../../controls/password/passwordFormConfig"
import SlbPopUp from "../../../controls/slbPopUp"
import { RenderForm } from "../../../jsonSchemaForm/formRenderer"

const _props = {
    user: {},
    title: '',
    show: false,
    setShowPopup: () => { },
    firstReset: false,
}
export function PasswordResetPopup(props = _props) {

    const form = useForm();
    const userInfo = useSelector(state => state.auth.userInfo) || {};
    const [isUpdating, setIsUpdating] = useState(false)
    const dispatch = useDispatch();

    function processData(formData) {
        const payload = {
            newPassword: formData.confirmPassword,
            emailId: props.user.emailId || props.user.email,
            modiFiedBy: userInfo.email
        }
        if (formData.confirmPassword) {
            setIsUpdating(true)
            dispatch(resetFormAuthentication(payload)) //encrypting the credentials payload during password reset
                .then((resp) => {
                    setIsUpdating(false)

                    if (resp?.payload?.status === 200) {
                        if (resp.payload.data?.isSuccess) {
                            dispatch(setKeyReset(true))
                            props.setShowPopup(false)
                            AppToast.Toast.success({ title: 'Password Reset', message: 'Password Changed Successfully.' })
                        }
                    }
                })
        }
        else {
            // AppToast.Toast.warning({ title: getConfiguredLabel(DocumentsPage, warning), message: getConfiguredLabel(DocumentsPage, downloadWarningMessage) })
        }
    }

    return <SlbPopUp
    size="md"
    className="slb-password-reset"
        show={props.show}
        title={props.title}
        buttons={
            {
                cancel: props.firstReset ? {} : {
                    label: 'Cancel', onClick: (event) => {
                        form.reset()
                        props.setShowPopup(false)
                    }, disabled: isUpdating
                },
                ok: {
                    label: 'Reset', onClick: (event) => {
                        form.handleSubmit(processData)()
                    }, disabled: isUpdating
                }

            }
        }
    >
        <RenderForm form={form} fields={PasswordFormFieldsConfig} user={props.user}/>
    </SlbPopUp>
}